import { useEffect, useState } from "react";
import Request from "../../../../api/Requests";
import { Link, useParams } from "react-router-dom";
import { Input } from "../../../Layout/Forms/Form";

const VenuesView = () => {
    const [isLoading, setIsLoading] = useState(true);
    let params = useParams();
    const [state, setState] = useState({
        form: []
    })

    useEffect(() => {
        getInfoVenue();
    }, [])

    const getInfoVenue = async () => {
        const response = await Request('admin/venues-get-info-view', 'GET', params, true);
        console.log(response.data)
        if (response && response.status) {
            setState({
                ...state,
                form: response.data
            })
            console.log(response.data)
        }
        setIsLoading(false);
    }

    return (isLoading ? <div>Loading...</div> : (
        <>
            <div className="row">
                <div className="col-12">
                    <h1>{state.form.name}</h1>
                </div>
            </div>
            <div className="row">
                {Object.entries(state.form).map(([key, value], index) => (
                    <div className="col-6" key={index}>
                        <Input
                            label={key}
                            value={typeof value === "object" ? JSON.stringify(value) : value}
                            disabled
                        />
                    </div>
                ))}


            </div>
        </>
    ));
}

export default VenuesView;